import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "bg-white m-2 rounded-lg text-xs"
};
const _hoisted_2 = {
  class: "flex justify-between items-center my-3"
};
const _hoisted_3 = {
  class: "text-left text-gray-900"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Step1Content',
  props: {
    title: null,
    data: null,
    clickTitle: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.title ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => __props.clickTitle && __props.clickTitle(...args))
      }, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (value, key) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", null, _toDisplayString(key) + " :", 1)]), _createElementVNode("p", _hoisted_3, _toDisplayString(value), 1)], 64);
      }), 256))])], 64);
    };
  }
});